import { render, staticRenderFns } from "./TextBlock.vue?vue&type=template&id=9931d57a&scoped=true&"
import script from "./TextBlock.vue?vue&type=script&lang=ts&"
export * from "./TextBlock.vue?vue&type=script&lang=ts&"
import style0 from "./TextBlock.vue?vue&type=style&index=0&id=9931d57a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../home/bearlogin/development/pinq-project/mono2/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9931d57a",
  null
  
)

export default component.exports